import { PARENT_GOLD_PRICE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export function PostParentGoldPrice(data){
  const api = `${PARENT_GOLD_PRICE_API}`;
  return axiosHttp.post(api, data);
}
